import { render, staticRenderFns } from "./nav-block.vue?vue&type=template&id=525ea794"
import script from "./nav-block.vue?vue&type=script&lang=js"
export * from "./nav-block.vue?vue&type=script&lang=js"
import style0 from "./nav-block.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports